import _ from 'lodash';
import desktop from './desktop';
import mobile from './mobile';

export const getDesktopConfig = _.memoize(desktop);
export const getMobileConfig = _.memoize(mobile);
